import axios from "axios";

const getTags = async () => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_SERVER_URL}/api/v1/company/tags`
        );

        return response.data || [];
    } catch (error) {
        console.error("Error fetching tags:", error);
        return [];
    }
};

export default getTags;
